import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListTransactions(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListReport(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction/report`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getListReportHistory(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction/history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListWithdrawHistory(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction/withdraw`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListStream(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction/stream`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListPurchase(authorization, filter) {
  const url = `${API_URL}/admin/in-web`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListRevenue(authorization, filter) {
  const url = `${API_URL}/admin/in-web`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getArtistBalance(authorization, artist_id) {
  const url = `${API_URL}/dashboard/artist/${artist_id}/balance`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getArtistEarning(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction/earning`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setRequestWithdrawal(authorization, data) {
  const url = `${API_URL}/dashboard/transaction/withdraw/request`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getCurrentStream(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction/stream/current`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getArtistEarningSummary(authorization, filter) {
  const url = `${API_URL}/dashboard/transaction/artist-earning`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/transactions.js